"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _SourceVolumeControl = _interopRequireDefault(require("./SourceVolumeControl"));
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _this = void 0; // permissions
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.TOGGLE_MUTE];
};
var SourceMediaControl = function SourceMediaControl(_ref) {
  var sourceId = _ref.sourceId,
    type = _ref.type,
    onVolumeChanged = _ref.onVolumeChanged,
    source = _ref.source,
    live = _ref.live,
    isAudioSource = _ref.isAudioSource,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions;
  if ([_.CAMERA_PRESENTER, _.SCREEN_PRESENTER, _.IMAGE_FILE, _.MEDIA].includes(type)) return null;
  var volumeControlProps = {
    type: type,
    live: live,
    sourceId: sourceId,
    isAudioSource: isAudioSource,
    muted: source.value.muted,
    volume: source.value.volume,
    onVolumeChanged: onVolumeChanged
  };
  var displayComponent = function displayComponent(enableFeature) {
    if (!enableFeature) {
      return null;
    }
    return _react["default"].createElement(_SourceVolumeControl["default"], (0, _extends2["default"])({
      enableFeature: enableFeature
    }, volumeControlProps));
  };
  return _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  });
};
SourceMediaControl.propTypes = {
  type: _propTypes["default"].string,
  onVolumeChanged: _propTypes["default"].func,
  sourceId: _propTypes["default"].string.isRequired,
  source: _propTypes["default"].object.isRequired,
  isAudioSource: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  live: _propTypes["default"].bool,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object
};
var _default = exports["default"] = SourceMediaControl;